import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { LoginFormData } from "../../types";
import endpoints from '../endpoints.json'

export function usePasswordChecker() {
    return useMutation((data: LoginFormData): Promise<any> => {
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            auth: {
                username: data.username,
                password: data.password
            },
            // data: {username: data.username, password: data.password} //formData
        }

        return axios(`${process.env.REACT_APP_SERVER_URL}/${endpoints.LOGIN}`, params)
    }, {
        mutationKey: ['checkPassword']
    });
}

